"use strict";
/**
 * addSuffixToDate function for adding suffix to day of month
 *
 * @param date - number
 *  @returns {string} - The formatted string, or empty string based on conditions.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.addSuffixToDate = void 0;
const addSuffixToDate = (date) => {
    if (date === undefined)
        return "";
    if (date <= 0)
        return "";
    if (date > 3 && date < 21)
        return `${date}th`;
    switch (date % 10) {
        case 1:
            return `${date}st`;
        case 2:
            return `${date}nd`;
        case 3:
            return `${date}rd`;
        default:
            return `${date}th`;
    }
};
exports.addSuffixToDate = addSuffixToDate;
